export default {

  button: {
    login: 'Connexion',
    logout: 'Déconnexion',
    changePassword: 'Modifier mon mot de passe',
    edit: 'Modifier',
    copy: 'Copier',
    update: 'Mettre à jour',
    detail: 'Détails',
    reset: 'Réinitialiser',
    search: 'Rechercher',
    export: 'Exporter',
    import: 'Importer',
    exportExcel: 'Exporter',
    control: 'Contrôler le dossier',
    distributor: {
      createProduct: 'Créer un produit'
    },
    lock: 'Verrouiller',
    unlock: 'Déverrouiller',
    delete: 'Supprimer',
    reinitPwd: 'Réinit. mot de passe',
    resetOtp: 'Réinit. OTP',
    cancel: 'Annuler',
    chooseFile: 'Choisir un fichier',
    save: 'Enregistrer',
    consult: 'Consulter',
    forceActivate: 'Forçage activation',
    inactivate: 'Inactiver',
    add: 'Ajouter',
    create: 'Créer',
    activate: 'Activer',
    deactivate: 'Désactiver',
    block: 'Bloquer',
    unblock: 'Débloquer',
    ok: 'OK',
    close: 'Fermer',
    displayErrors: 'Afficher les erreurs',
    confirm: 'Confirmer'
  },

  img: {
    logo: 'Logo Up'
  },

  login: {
    form: {
      login: 'Identifiant',
      password: 'Mot de passe'
    },
    footer: '© Worldline -'
  },

  label: {
    logout: {
    warning: "Vous serez déconnecté dans 1 minute en raison d'une inactivité de 15 minutes.\n Veuillez bouger la souris ou appuyer sur une touche pour rester connecté.",
    disconnected: "Vous avez été déconnecté en raison d'une inactivité."
    },
    actions: 'Actions',
    results: {
      show: 'Afficher',
      number: 'éléments sur 1 trouvé | éléments sur {count} trouvés'
    },
    affiliate: {
      selectedDistributorRef: 'Distributeur',
      selectedCommercialProduct: 'Produit commercial',
      selectedAffiliateStatus: 'Statut contrat affilié',
      selectedContractId: 'Identifiant contrat affilié',
      selectedProviderId: 'Identifiant prestataire technique',
      selectedMerchantId: 'Identifiant marchand',
      selectedCreationDateStart: 'Date de création, du',
      selectedCreationDateEnd: 'Au',
      selectedClosingDateStart: 'Date de fermeture, du',
      selectedClosingDateEnd: 'Au',
      detail: {
        detail: 'Détails',
        contractId: 'Identifiant contrat affilié',
        distributorId: 'Distributeur',
        productId: 'Identifiant produit',
        maxAmountLoad: 'Plafond de chargement',
        minAmountLoad: 'Plancher de chargement',
        maxAmountUnload: 'Plafond de déchargement',
        minAmountUnload: 'Plancher de déchargement',
        balance: 'Solde',
        mcc: 'Mcc',
        countryCode: 'Code pays',
        address: 'Adresse',
        phone1: 'Téléphone 1',
        phone2: 'Téléphone 2',
        email: 'Email',
        creationDate: 'Date de création',
        status: 'Statut',
        statusDate: 'Date de mise à jour du statut',
        activationDate: 'Date d\'activation',
        inactivationDate: 'Date d\'inactivation',
        closingDate: 'Date de fermeture',
        closingEffectiveDate: 'Date effective de fermeture',
        providerList: 'Liste des prestataires techniques',
        providerId: 'Identifiant prestataire technique',
        connectionMode: 'Mode de raccordement',
        merchantList: 'Liste des marchands',
        merchantId: 'Identifiant marchand',
        structureId: 'Identifiant structure',
        channelList: 'Canaux d\'acceptation',
        messageList: 'Messages autorisé',
        IdInfosGroupeFiltrage1: 'Groupe filtrage 1',
        IdInfosGroupeFiltrage2: 'Groupe filtrage 2',
        IdInfosGroupeFiltrage3: 'Groupe filtrage 3',
        IdInfosGroupeFiltrage4: 'Groupe filtrage 4',
        IdInfosGroupeFiltrage5: 'Groupe filtrage 5',
        addProviderLowerCase: 'Ajouter un prestataire',
        addMerchantLowerCase: 'Ajouter un marchand',
        addProvider: {
          providerId: 'Identifiant prestataire technique',
          providerIdInfo: 'Champ obligatoire. 45 caractères maximum.',
          connectionMode: 'Mode de raccordement',
          connectionModeInfo: 'Champ obligatoire.',
          addProvider: 'AJOUTER UN PRESTATAIRE',
          editProvider: 'MODIFIER LE PRESTATAIRE',
          deleteProvider: 'SUPPRIMER LE PRESTATAIRE',
          confirmationDeleteProvider: 'Voulez-vous supprimer le prestataire',
        },
        addMerchant: {
          addMerchant: 'AJOUTER UN MARCHAND',
          editMerchant: 'MODIFIER LE MARCHAND',
          deleteMerchant: 'SUPPRIMER LE MARCHAND',
          confirmationDeleteMerchant : 'Voulez-vous supprimer le marchand',
          provider: 'Prestataire',
          legend: 'Nouveau marchand associé au prestataire',
          merchantId: 'Identifiant marchand',
          merchantIdInfo: 'Champ obligatoire. 45 caractères maximum.',
          structureId: 'Identifiant structure',
          structureIdInfo: '45 caractères maximum.',
          acceptanceChannels: 'Canaux d\'acceptation',
          acceptanceChannelsInfo: 'Champ obligatoire. PDP et/ou VAD',
          acceptanceChannelsPDP: 'PDP',
          acceptanceChannelsVAD: 'VAD',
          allowedMessages: 'Messages autorisés',
          allowedMessagesInfo: 'Si aucun message n\'est sélectionné, tous les messages seront associés au marchand',
          filteringGroup1: 'Groupe de filtrage 1',
          filteringGroup1Info: 'Filtre de 3 caractères. 101 filtres maximum.',
          filteringGroup2: 'Groupe de filtrage 2',
          filteringGroup3: 'Groupe de filtrage 3',
          filteringGroup4: 'Groupe de filtrage 4',
          filteringGroup5: 'Groupe de filtrage 5'
        }
      }
    },
    card: {
      distributor: 'Distributeur',
      commercialProduct: 'Produit commercial',
      funderContract: 'Contrat financeur',
      beneficiaryService: 'Service bénéficiaire',
      cardId: 'Identifiant carte',
      cardNum: 'Numéro de carte',
      expirationDate: 'Date d\'expiration',
      sequenceNumber: 'Numéro de séquence',
      cardStatus: 'Statut carte',
      activationDate: 'Date d\'activation',
      creationDate: 'Date de création',
      cardInfo: 'PAN / Date d\'expiration / PSN',
      orderStatus: 'Statut commande',
      expeditionRef: 'Ref expédition',
      productionRef: 'Ref fabrication',
      status: 'Statut',
      detail: {
        cardDetails: 'DÉTAILS CARTES',
        cardEvent: {
          ExtActivationEvent: 'Activation',
          ExtBlockingCardEvent: 'Blocage',
          ExtDeactivationCardEvent: 'Désactivation',
          ExtFirstIssueCardEvent: 'Premier envoi',
          ExtRenewalCardEvent: 'Renouvelement',
          ExtReplacementCardEvent: 'Remplacement',
          ExtUnblockingCardEvent: 'Déblocage'
        },
        // Détails
        details: 'Détails',
        distributor: 'Distributeur',
        product: 'Produit',
        beneficiary: 'Bénéficiaire',
        funder: 'Financeur',
        cardId: 'Identifiant carte',
        pan: 'PAN',
        cardExpiryDate: 'Date d\'expiration',
        psn: 'Numéro de séquence',
        cardStatus: 'Statut carte',
        logoRef: 'Référence logo',
        activationDate: 'Date d\'activation',
        activationLimitDate: 'Date d\'activation limite',
        artworkRef: 'Référence du visuel de la carte',
        funderName: 'Nom financeur',
        cardStatusReason: 'Code motif en complément du statut',
        orderRef: 'Référence fabrication commande',
        expeditionOrderRef: 'Référence expédition commande',
        orderStatus: 'Statut commande',
        issuingDate: 'Date d\'envoi',
        blockingDate: 'Date de blocage de la carte',
        lostStolenDate: 'Date perdue/volée de la carte',
        embossingName: 'Nom embossé sur la carte',
        packagingRef: 'Référence packaging',
        pinTryCounter: 'Nombre maxi saisie code PIN faux',
        contactLessCardInterfaceStatus: 'Statut de l\'interface \'sans contact\' carte',
        cardProfileRef: 'Référence profil équipement porteur',
        emvProfileId: 'Référence du profil EMV',
        documentRef: 'Référence du document',
        emvCmdList: 'Liste commandes EMV créées pour la carte',
        emvCmdDate: '',
        emvCmdstatus: '',
        emvCmdtype: '',
        emvCmdretryCounter: '',
        cardEventList: 'Evènements sur la carte',
        cardEventType: 'Type d\'évènement',
        cardEventDate: 'Date de l\'évènement',
        cardEventCardId: 'Identifiant de la carte',
        pKeySensitiveLabel: 'Clé digitale',
        pKeySensitiveDataId: 'Identifiant de la clé',
        pKeyCreationDate: 'Date de création de la clé',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        // Compte
        account: 'Compte',
        balance: 'Solde',
        available: 'Disponible',
        beneficiaryAccount: 'Compte bénéficiaire',
        amount: 'Montant',
        // Cartes
        cards: {
          cards: 'Cartes',
          cardId: 'Identifiant carte n°',
          cardStatus: 'Statut',
          panCard: 'PAN',
          psnCard: 'PSN',
          expiryDate: 'Date d\'expiration'
        },
        // Commandes
        orders: {
          commands: 'Commandes',
          expeditionRef: 'Ref expédition',
          orderStatus: 'Statut commande',
          documentRef: 'Référence du document',
          personalizedCardData: 'Données personnalisation support',
          personalizedInsetData: 'Données encart carte',
          otherDataList: 'Autres données'
        },
        modal : {
          cardActivation: 'ACTIVATION DE LA CARTE',
          loadOption: 'Vous pouvez optionnellement charger le compte pendant l\'activation de la carte avec le formulaire ci-dessous.',
          eur: 'EUR',
          cardDeactivation: 'DÉSACTIVATION DE LA CARTE',
          reason: 'Raison',
          cardBlocking: 'BLOCAGE DE LA CARTE'
        },
        tokenData: 'Tokens',
        tokenId: 'IdToken',
        tokenUniqueReference: 'Réf unique du token MP',
        consumerFacingEntityName: 'Nom affiché au consommateur',
        tokenStatus: 'Statut',
        tokenExpiryDate: 'Date de fin de validité'
      }
    },
    account: {
      selectedDistributorRef: 'Distributeur',
      selectedCommercialProduct: 'Produit commercial',
      selectedFunderContract: 'Contrat financeur',
      selectedBeneficiaryService: 'Service bénéficiaire',
      selectedAccountStatus: 'Statut Compte',
      selectedCreationDate: 'Date de création',
      selectedClosingDate: 'Date de fermeture',
      distributorRef: 'Référence du distributeur',
      productRef: 'Référence du produit',
      status: 'Statut',
      category: 'Catégorie',
      accountNumber: 'Numéro de compte',
      balance: 'Solde',
      openToBuy: 'Disponible',
      singleFunderAccount: 'Compte Financeur Unique',
      dataFromCFU: 'Données provenant du compte financeur unique',
      dataFromSB: 'Données provenant du service bénéficiaire',
      beneficiaryStatus: 'Statut bénéficiaire',
      details: 'Détails',
      beneficiary: 'Bénéficiaire',
      funder: 'Financeur',
      product: 'Produit',
      beneficiaryServiceProfile: 'Profil service bénéficiaire',
      account: 'Compte',
      funderAccount: 'Compte financeur',
      beneficiaryAccount: 'Compte bénéficiaire',
      cards: 'Cartes',
      orders: 'Commandes',
      operations: 'Opérations',
      notificationData: 'Données de notification',
      noElement: 'Aucun élément à afficher',
      detail: {
        beneficiaryAccountDetails: 'DÉTAILS COMPTE BÉNÉFICIAIRE',
        funderAccountDetails: 'DÉTAILS COMPTE FINANCEUR',
        accountStatus: 'Statut compte',
        rightReference: 'Référence du droit',
        startDate: 'Date de début',
        expirationDate: 'Date d\'expiration',
        statusReasonCode: 'Statut / Code raison',
        loadedAmountRemaining: 'Montant chargé / restant',
        actions: 'Actions'
      },
      operation: {
        voucherOperations: 'Opérations du voucher',
        operationId: 'ID Opération',
        operationType: 'Type de l\'opération',
        extReference: 'Référence externe',
        operationDate: 'Date de l\'opération',
        consult: 'Consulter'
      },
      restriction: {
        restrictions: 'Restrictions',
        maxAmountLoad: 'Plafond chargement compte',
        minAmountLoad: 'Plancher chargement compte',
        maxAmountUnload: 'Plafond déchargement compte',
        minAmountUnload: 'Plancher déchargement compte',
        minPurchaseLimit: 'Limite minimum d\'achat',
        maxPurchaseLimit: 'Limite maximum d\'achat',
        fixedProhibitedPeriods: 'Périodes fixes interdites',
        authorizedUtilizationDays: 'Jours utilisation autorisés',
        MCCRestrictions: 'Restrictions MCC',
        authorizedUtilizationHours: 'Heures utilisation autorisées',
        paymentsRestrictionsFixedPeriod: 'Restriction sur les paiements - Période fixe',
        periodType: 'Type de période',
        maxAmountUnloadPeriod: 'Plafond maximal par période',
        maxNumberPeriod: 'Nombre maximal par période',
        transactionType: 'Type de transaction',
        paymentsRestrictionsSlidingPeriod: 'Restriction sur les paiements - Période glissante',
      }
    },
    operation: {
      operationDetail: 'DÉTAILS DE L\'OPÉRATION',
      details: 'Détails',
      status: 'Statut',
      acquisitionCountryCode: 'Code pays accepteur',
      acquisitionDate: 'Date d\'acquisition',
      acquisitionMaterial: 'Matériel d\'acquisition',
      cardSchemeCode: 'Identifiant réseau carte',
      entryMode: 'Mode de lecture',
      externalReference: 'Référence externe',
      genericMCC: 'Code MCC',
      merchantNameAndLoc: 'Nom et locatisation marchand',
      operationCode: 'Code opération',
      operationDate: 'Date locale opération',
      originalAmount: 'Montant d\'origine',
      reversal: 'Flag annulation',
      reversalReason: 'Motif annulation',
      validationMode: 'Mode authentification porteur',
      valueDate: 'Date imputation opération',
      cardExternalReference: 'Référence externe carte',
      account: 'Compte',
      cards: 'Cartes',
      orders: 'Commandes'
    },
    authorization: {
      distributor: 'Référence du Distributeur',
      holderNumber: 'N° Porteur',
      cardId: 'Identifiant de la carte',
      authorizationNumber: 'N° Autorisation',
      authorizationDate: 'Date Autorisation',
      startDate: 'Date de début',
      startTime: 'Heure de début',
      endDate: 'Date de fin',
      endTime: 'Heure de fin',
      id: '#',
      merchantId: 'N° Contrat commerçant',
      transactionType: 'Type de transaction',
      amount: 'Montant',
      amountFormat: 'Indiquer dans la plus petite unité possible de la devise',
      currency: 'Devise',
      responseCode: 'Code réponse',
      responseCodeDetailed: 'Code réponse détaillé',
      acceptanceChannel: 'Canal d\'acceptation',
      date: 'Date',
      dateType: 'Date de la transaction',
      codeRp: {
        _00: '- Autorisation accordée pour le montant demandé \n- Demande de renseignement non refusée',
        _10: 'Autorisation accordée partiellement, dans la limite du solde disponible',
        _03: 'Accepteur invalide',
        _04: 'Suspicion d\'utilisation abusive',
        _05: '- Ne pas honorer \n- Transaction non permise au porteur \n- Transaction invalide',
        _12: 'Transaction invalide (non traitée par le serveur)',
        _13: 'Montant invalide',
        _14: 'Numéro de porteur invalide',
        _25: 'Impossible de localiser l\'enregistrement dans le fichier',
        _29: 'Mise à jour de fichier impossible',
        _30: 'Erreur syntaxique',
        _34: 'Carte contrefaite',
        _40: 'Retrait sans contact non autorisé',
        _41: 'Carte perdue',
        _43: 'Carte volée',
        _46: 'Transaction invalide (code de réponse généré par SAER pour date de transaction invalide)',
        _47: 'Nombre maximum de codes PIN incorrects atteint',
        _51: 'Provision insuffisante',
        _54: 'Date de validité de la carte dépassée',
        _55: 'Code confidentiel erroné',
        _56: 'Carte absente du fichier',
        _57: 'Transaction non permise au porteur',
        _58: 'Transaction non permise pour ce terminal',
        _59: 'Suspicion de fraude',
        _61: 'Montant de retrait hors limite',
        _63: 'Règles de sécurité non respectées',
        _65: 'Limite de fréquence dépassée pour transactions sans contact',
        _75: 'Nombre d\'essais code confidentiel dépassé',
        _94: 'Demande dupliquée',
        _91: 'Time out',
        _96: 'Erreur système du FO Financeur',
        _98: 'Serveur FO Financeur indisponible',
        _99: 'Incident de domaine initiateur',
        _A0: 'Repli en mode contact (mode dégradé)',
        _A1: 'Refus léger (commerce éléctronique uniquement), 3DS avec défi requis',
        _A2: 'Demande de saisie du code PIN en mode Single tap',
        _A3: 'Nouveau TAP avec authentification requise',
        _B0: 'Le service obligatoire ne peut pas être effectué'
      },
      detail: {
        // ---- Données générales ----
        generalData: 'Données générales',
        referenceDistributeur: 'Reference Distributeur',
        typeTransaction: 'Type Transaction',
        dateTransaction: 'Date Transaction',
        dateTransmissionTransaction: 'Date Transmission',
        dateMoveUp: 'Date MoveUp',
        numAut: 'N° Autorisation',
        codeRetour: 'Code Retour',
        codeRaisonDetaillee: 'Code Raison Detail',
        canalAcceptationValue: 'Canal Acceptation',
        idAcceptation: 'ID Acceptation',
        countryCode: 'Code Pays',
        idTerminal: 'ID Terminal',
        traceNumber: 'N° Trace',
        posEntryMode: 'Mode Entrée Pos',
        scheme: 'Scheme',
        mask: 'Masque',
        typeFacture: 'Type Facture',
        acceptationContext: 'Acceptation Context',
        retrievalReferenceNumber: 'RRN',
        regularizationFlag: 'Top Regularisation',
        authorizationReference: 'Reference Autorisation',
        referenceProduit: 'Reference Produit',
        preAuthorizationFlag: 'Top Pre-Autorisation',
        posData: 'Donnée Pos',
        traceId: 'ID Trace',
        transactionLinkId : 'TLID',
        transactionReference : 'Reference Transaction',
        merchantSingleTapIndicator: 'Indicateur single tap',
        codeMotifAutorisationSingleTap: 'Code Motif Autorisation Single Tap',
        blockPINAlgorithm: 'Algorithme bloc PIN',
        blockPINFormat: 'Format bloc PIN',
        transactionAnalysisOverview: 'Décision sur la transaction',
        transactionAnalysisTestResults: 'Liste des contrôles en échec',
        regularizationOrigine: 'Origine de la régularisation',
        directSettlementMode: 'Ind Direct Settlement',
        saerDeclined: 'Rejet Saer',
        idAppel: 'Id Appel',
        networkOrigin: 'Prestataire tech. d’acceptation',
        protocole: 'Protocole',
        // ---- Données du commerçant ----
        marchandData: 'Données du commerçant',
        cardholderMerchantInitiatorTrInd: 'Indicateur initiateur transaction',
        finalAuthorizationIndicator: 'Indicateur Final Autorisation',
        idContratAffilie: 'ID Contrat Affilie',
        idMarchand: 'ID Marchand',
        nomMarchand: 'Nom Marchand',
        villeMarchand: 'Ville Marchand',
        codepostalMarchand: 'Code Postal Marchand',
        paysMarchand: 'Pays Marchand',
        referenceListe: 'Identifiant liste de filtrage',
        idStructure: 'ID Structure',
        codeMCC: 'Code MCC',
        domesticAcceptorTaxId: 'Identifiant fiscal commerçant / SIRET',
        accountCategory: 'Categorie Compte',
        accountNumber: 'N° Compte',
        paymentFacilitatorId: 'ID facilitateur de paiement',
        independentSalesOrgId: 'ID organisation commerciale indépendante',
        subMerchantId: 'ID marchand final',
        merchantCountryOrigin: 'Pays origine du marchand',
        // ---- Données porteur ----
        porteurData: 'Données du porteur',
        numCarte: 'N° Porteur',
        psnCarte: 'PSN Carte',
        cardId: 'ID Carte',
        cardExpiryDate: 'Date Expiration Carte',
        referenceContratFinanceur: 'Reference Contrat Financeur',
        referenceServiceBeneficiaire: 'Reference Service Beneficiaire',
        // ---- Données monétaires ----
        monetaireData: 'Données monétaires',
        amount: 'Montant',
        feeAmountAndSign: 'Montant du frais sur la transaction et sens',
        sameCurrency: 'Même devise que la transaction',
        currencyCode: 'Code devise',
        solde: 'Solde',
        actualAmount: 'Montant Autorisé',
        cardholderAmount: 'Montant Devise Porteur',
        cardholderConversionRate: 'Taux conv. Porteur',
        cardholderCurrency: 'Code devise Porteur',
        complementAmount: 'Montant Complément',
        replacementAmount: 'Montant de remplacement',
        cardholderReplacementAmount: 'Montant rempl. Porteur  ',
        accountDetailList: 'Détail des comptes',
        cashWithDrawalAccountAvailable: 'Disponible retrait',
        purchaseAccountAvailable: 'Disponible achat',
        purchaseAccountAvailableException: 'Exception disponible achat',
        // ---- Données spécifiques à la réponse autorisation ----
        authRespSpeciData: 'Données spécifiques à la réponse autorisation',
        respAcceptorMessage: 'Msg emet pour accept',
        respIssuerMessage: 'Msg emet pour port',
        respPartialApprovalFlag: 'Top aut partiel',
        respCardStatus: 'Statut Carte',
        respCardExpiryDate: 'Date Exp Carte',
        // ---- Données spécifiques aux annulations, redressements et avis générant un redressement ----
        annulRedresSpeciData: 'Données spécifiques aux annulations, redressements et avis générant un redressement',
        oriAcquirerId: 'ID Acq Origine',
        oriMontant: 'Montant Origine',
        oriDateTransaction: 'Date Origine',
        oriTraceNumber: 'N° Trace Origine',
        onlinePartialReversalParam: 'Redressement partiel autorisé',
        onlinePartialReversalParam0: 'non autorisé',
        onlinePartialReversalParam1: 'autorisé pour 0120',
        onlinePartialReversalParam2: 'autorisé pour 0400-DE95',
        onlinePartialReversalParam3: 'autorisé pour 0120 et 0400-DE95',
        oriAuthorizationReference: 'Référence autorisation initiale',
        // ---- Données Voucher ----
        vaucherData: 'Données Voucher',
        externalReference: 'Reference Externe Voucher',
        amountImpact: 'Montant Voucher',
        // ---- Données sécuritaires ----
        securitairesData: 'Données sécuritaires',
        transacIdAcceptor: 'ID Accepteur Transaction',
        cryptogram: 'Cryptogramme',
        securityType: 'Type Sécurisation',
        cryptogramProcessInfo: 'Trt cryptogramme',
        cardholderAuthMethod: 'Meth auth porteur',
        cryptogramCalcMethod: 'Meth calcul cryptogramme',
        onBehalfServices: 'Services utilisés pour la transation',
        securityServicesData: 'Services de sécurité intégrés',
        additionalData: 'Données compl',
        indicator: 'Indi commerce élect',
        walletName: 'Nom Wallet',
        walletAdditionalData: 'Données compl wallet',
        walletIdentifier: 'Id wallet',
        tokenId: 'ID token',
        tokenAccountNumber: 'N° Compte Token',
        tokenExpiryDate: 'Date Exp Token',
        tokenRequestorId: 'ID Demandeur Token',
        tokenType: 'Type Token',
        tokenStorageType: 'Mode stockage token',
        tokenAssuranceLevel: 'Ind niveau token',
        deviceType: 'Type d\'équipement',
        tokenWalletId: 'ID Wallet',
        lastEmvCommandResult: 'Résul exec cde EMV',
        protocolVersion: 'Version Protocole',
        directoryServerTransactionId: 'Id trans Directory server',
        // ---- Données spécifiques avis d\'autorisation ----
        avisAuthSpeciData: 'Données spécifiques avis d\'autorisation',
        codeRetourRequest: 'Code Retour Avis Autorisation',
        codeRetourDetailleRequest: 'Code Retour Detail Avis Autorisation',
        avisCodeMotif: 'Code Motif Avis Autorisation',
        // ---- Données spécifiques SCP ----
        scpSpeciData: 'Données spécifiques SCP',
        scpRequestDate: 'Date Demande SCP',
        scpResponseDate: 'Date Réponse SCP',
        substitutionPaymentReason: 'Motif SCP',
        scpResponseCode: 'Code réponse SCP',
        scpNeedReversal: 'Redressement demandé par le SCP',
        saeCallData: 'Données d\'appel SAE externe',
        accountAvailable: 'Solde disponible',
        amountAdjusted: 'Montant ajusté',
        extSaeRequestDate: 'Date d\'appel',
        extSaeResponseCode: 'Code retour',
        extSaeResponseDate: 'Date de réponse',
        opType: 'Type opération',
        rejectNotificationReason: 'Raison du rejet de la notification',
        partialAuthorizationSupported: 'Autorisation partielle supportée',
        partialAuthYes: 'Oui',
        partialAuthNo: 'Non',
        extSaeSpeciData: 'Données spécifiques SAE Externe',
        accountUpdatableExtSae: 'Éligibilité du compte à la mise à jour par le SAE Externe',
        accountUpdatableYes: 'Oui',
        accountUpdatableNo: 'Non',
        ert: 'ERT (Env technique et réglementaire)',
        functionCode: 'Code fonction',
        acquirerCountryCode: 'Code pays de l\'acquéreur'
      }
    },
    order: {
      orders: 'COMMANDES',
      orderType: 'Type commande *',
      orderStatus: 'Statut commande',
      expeditionRef: 'Référence expédition',
      orderRef: 'Réference commande fabrication',
      close: 'Close',
      orderDetails: 'DÉTAILS COMMANDE',
      details: {
        pinRepublication: 'Réédition PIN',
        distributor: 'Distributeur',
        funderContract: 'Contrat financeur',
        beneficiary: 'Bénéficiaire',
        product: 'Produit',
        orderType: 'Type commande',
        expeditionRef: 'Référence expédition',
        orderStatus: 'Statut commande',
        cardIdentifier: 'Identifiant carte',
        PAN: 'PAN',
        expirationDate: 'Date d\'expiration',
        sequenceNumber: 'Numéro de séquence',
        cardVisualReference: 'Référence du visuel de la carte',
        manufacturer: 'Fabricant',
        sortCriteria: 'Critères de tri',
        trackingDataList: 'Liste données de suivi de colis',
        documentReference: 'Référence document',
        expeditionDate: 'Date d\'expédition',
        orderReference: 'Date de la commande',
        mobilePhoneNumber: 'Numéro de téléphone portable',
        customizationType: 'Type de personnalisation',
        deliveryAddress: 'Adresse de livraison',
        line1: 'Ligne 1',
        line2: 'Ligne 2',
        line3: 'Ligne 3',
        line4: 'Ligne 4',
        line5: 'Ligne 5',
        countryCode: 'Code pays',
        landlinePhoneNumber: 'Numéro de téléphone fixe',
        city: 'Ville',
        postalCode: 'Code postal',
        deliveryType: 'Type de livraison',
        addresseeEmailPinCode: 'Email destinataire envoi code PIN',
        embossedNameOnCard: 'Nom embossé sur la carte',
        extractionReference: 'Référence de l\'extraction',
        orderHistory: 'Historique de la commande',
        statusChangeDate: 'Date de changement de statut',
        logoReference: 'Référence logo',
        defaultDeliveryAddress: 'Adresse de livraison par défaut',
        fileNumber: 'Numéro de fichier',
        orderReason: 'Raison de la commande',
        packageNumber: 'Numéro du package',
        packagingRef: 'Référence packaging',
        customCardMessage: 'Message carte personnalisé',
        customizationElementsCardSlot: 'Eléments de personnalisation de l\'encart carte',
        customedMessage: 'Message personnalisé',
        manufacturingStatusHistory: 'Historique des status de fabrication',
        manufacturingStatus: 'Statut de la fabrication',
        manufacturingDate: 'Date de fabrication',
        manufacturingOrderRef: 'Référence commande fabrication',
        rejectDate: 'Date de rejet',
        packageSenderRef: 'Référence de l\'expéditeur du colis',
        sendingType: 'Type d\'envoi',
        cardOrderSequenceNumber: 'Numéro de séquence de la commande la carte',
        noAddress: 'Aucune adresse',
        address: 'Adresse',
        email: 'Email',
        beneficiaryAccount: 'Compte bénéficiaire',
        cardPinRepublication: 'RÉÉDITION DU CODE PIN DE LA CARTE',
        sendingMode: 'Mode d\'envoi',
        date: 'Date',
        pinCodePublisher: 'Éditeur code PIN',
        pinSendingType: 'Type d\'envoi de PIN',
        cancel: 'Annuler'
      }
    },
    clearing: {
      selectedDistributorRef: 'Référence du Distributeur',
      selectedScheme: 'Réseau carte',
      selectedPan: 'N° Porteur',
      selectedCardId: 'Identifiant de la carte',
      selectedIdOperation: 'Identifiant transaction',
      selectedNumAut: 'N° Autorisation',
      selectedClasseTransaction: 'Catégorie transaction',
      selectedTransactionStatus: 'Statut technique',
      selectedDateTransactionBegin: 'Date de début transaction',
      selectedTimeTransactionBegin: 'Heure de début transaction',
      selectedDateTransactionEnd: 'Date de fin transaction',
      selectedTimeTransactionEnd: 'Heure de fin transaction',
      selectedDateTraitementBegin: 'Date de début traitement',
      selectedTimeTraitementBegin: 'Heure de début traitement',
      selectedDateTraitementEnd: 'Date de fin traitement',
      selectedTimeTraitementEnd: 'Heure de fin traitement',
      selectedTransactionAmount: 'Montant',
      selectedCurrencyCode: 'Devise d\'origine',
      distributorRef: 'Référence du Distributeur',
      cardSchemeCode: 'Réseau carte',
      pan: 'N° Porteur',
      cardId: 'Identifiant carte',
      transactionCategory: 'Catégorie transaction',
      IdOperation: 'Identifiant transaction',
      dateTransaction: 'Date transaction',
      processingDate: 'Date traitement',
      transactionAmount: 'Montant',
      currencyCode: 'Devise du montant origine',
      reversalFlag: 'Top Annulation',
      offlineAutReversalFlag: 'Top Redr. Offline',
      numAut: 'N° Autorisation',
      detail: {
        transaction: {
          // ---- Données générales ----
          generalData: 'Données générales d\'une transaction',
          idOperation: 'Identifiant transaction',
          classeTransaction: 'Catégorie transaction',
          technicalStatus: 'Statut technique',
          technicalErrorType: 'Type erreur technique',
          technicalErrorDetail: 'Détail erreur technique',
          clearingStatus: 'Statut métier',
          transmissionDateAndTime: 'Date transmission',
          processingDate: 'Date traitement',
          transactionStatus: 'Statut transaction litige MCI',
          rejectReasonCode: 'Raison rejet MCI',
          partialFlag: 'Indicateur partiel',
          partialNumber: 'Nombre partiel',
          claimCbkId: 'Identifiant réclamation',
          cbkId: 'Identifiant du litige',
          cardIssuerReferenceData: 'Référence Emetteur',
          reasonCode: 'Code Motif',
          messageText: 'Message complémentaire',
          reversalFlag: 'Indicateur annulation',
          direction: 'Sens',
          collectionDisbursementFlag: 'Indicateur recouvrement de frais',
          typeFacture: 'Type Facture',
          accountholderAuthenticationValue : 'Valeur authentification porteur',
          // Emetteur
          emetteur: 'Emetteur',
          issuerId: 'Ref Distributeur',
          distributorRef: 'Nom du Distributeur',
          memberId: 'Membre destination (ICA)',
          memberIdRec: 'Membre adhérent destinataire',
          cardSchemeCode: 'Réseau carte',
          technicalProduct: 'Référence produit technique',
          brand: 'Marque',
          pan: 'N° porteur',
          cardId: 'Identifiant carte',
          expiryDate: 'Date exp carte',
          psn: 'PSN carte',
          referenceProduitCommercial: 'Reference produit commercial',
          cardStatus: 'Statut carte',
          refServiceBenef: 'Ref Service Benef',
          libServiceBenef: 'Lib Service Benef',
          productExternalReference: 'Référence produit',
          beneficiaryServiceExternalReference: 'Référence service bénéficiaire',
          distributorData: 'DONNÉES DISTRIBUTEUR',
          beneficiary: 'BÉNÉFICIAIRE',
          funder: 'FINANCEUR',
          // Acquéreur
          acquereur: 'Acquéreur',
          acquiringBIN: 'BIN Acquéreur',
          idContratAffilie: 'Id affilié',
          idMarchand: 'Identifiant Marchand',
          idStructure: 'Identifiant Structure',
          domesticAcceptorTaxId: 'Identifiant fiscal commerçant / SIRET',
          accountCategory: 'Catégorie de compte',
          accountNumber: 'N° compte',
          nomMarchand: 'Nom Marchand',
          rueMarchand: 'Adresse Marchand',
          villeMarchand: 'Ville Marchand',
          codepostalMarchand: 'Code postal Marchand',
          regionMarchand: 'Région Marchand',
          countryCode: 'Pays Marchand',
          idTerminal: 'Id Terminal',
          idAcceptation: 'Id Accept',
          codeMCC: 'MCC',
          acquirerReferenceNumber: 'Reference Acquereur (ARN)',
          retrievalReferenceNumber: 'RRN',
          matchingAlgorithm: 'Algorithme de réconciliation',
          level: 'Niveau ',
          authorizationReferenceList: 'Liste Ref Autorisation',
          traceNumber: 'N° audit',
          idRemise: 'Identifiant remise',
          paymentFacilitatorId: 'Identifiant du facilitateur de paiement',
          subMerchantId: 'Identifiant du marchand final',
          // Détail opération
          detailOperation: 'Détail opération',
          transactionType: 'Type transaction',
          canalAcceptationValue: 'Canal d\'acceptation',
          posEntryMode: 'Condition réalisation trs',
          transactionOriginatorInstitutionIdCode: 'Code traitement compte d\'origine',
          transactionDestinationInstitutionIdCode: 'Code traitement compte destinataire',
          dateTransaction: 'Date transaction',
          transactionAmount: 'Montant transaction',
          reconciliationAmount: 'Montant reconciliation',
          exchangeRate: 'Taux de change devise reconciliation',
          cardHolderBillingAmount: 'Montant transaction devise compte beneficiaire',
          cardholderConversionRate: 'Taux de change devise compte bénéficiaire   ',
          amountBeforeTopUp: 'Amount Before TopUp',
          complementAmount: 'Complement Amount',
          clearingPaymentComplement: 'Complément paiement compensation',
          interchangeFees: 'Montant frais interchange',
          codeFraisInterchange: 'Code frais interchange',
          settlementDate: 'Date règlement',
          authorizationOrigin: 'N° Autorisation',
          traceId: 'Id cycle de vie transaction réseau',
          transactionLinkId : 'TLID',
          cardholderMerchantInitiatorTrInd: 'Indicateur initiateur transaction',
          originalIdOperation: 'Trans origine',
          directSettlementMode: 'Ind Direct Settlement',
          directSettlementInformation: 'Info Direct Settlement',
          insufficientBalanceFlag: 'Indicateur solde insuffisant',
          // Impact voucher
          impactVoucher: 'Impact voucher',
          externalReference: 'Reference externe du droit',
          accountImpact: 'Montant impacté sur le droit',
          // Données « Sécuritaires »
          donneesSecuritaires: 'Données sécuritaires',
          ecommDef: 'E-Commerce',
          ecommData: 'Données e-commerce',
          mdesData: 'Données MDES',
          ecomm: {
            donneesSecuritaires: 'Données « Sécuritaires »',
            transacIdAcceptor: 'Identifiant transaction accepteur',
            cardholderAuthMethod: 'Methode authentification porteur',
            indicator: 'Indicateur commerce élect',
            cryptogram: 'Cryptogramme',
            cryptogramCalcMethod: 'Methode calcul cryptogramme',
            cryptogramProcessInfo: 'Traitement cryptogramme',
            resultUseSecArch: 'Résultat',
            securityType: 'Type sécurisation',
            modifiedSecurityMode: 'Mode sécurisation',
            additionalData: 'Données complémentaires',
            walletAdditionalData: 'Données complémentaires wallet',
            walletName: 'Nom wallet',
            walletIdentifier: 'Identifiant wallet',
            securityProtocol: 'Type de protocole sécurité (MCI)',
            cardholderAuthentification: 'Type d\'authentification porteur (MCI)',
            ucafCollectionIndicator: 'Indicateur de collecte UCAF (MCI)',
            directoryServerTransactionId: 'Id trans Directory server',
            programProtocol: 'Version protocole'
          },
          xpayDef: 'MDES',
          xpay: {
            tokenRequestorId: 'ID Demandeur Token',
            deviceType: 'Type d\'équipement',
            tokenWalletId: 'Identifiant wallet',
            tokenType: 'Type token',
            tokenAccountNumber: 'N° Compte Token',
            tokenAssuranceLevel: 'Ind niveau token',
          },
          // Données « Fichier clearing »
          donneesFichierCompensation: 'Données « Fichier clearing »',
          dateFichier: 'Date fichier',
          dateExtraction: 'Date extraction',
          statutExtraction: 'Statut extraction',
          dateExtraction_: 'Date extraction',
          fileId: 'Identifiant fichier réseau',
          numMessage: 'N° message',
          // Export
          cardSchemeTransactionCycleId: 'Schema du cycle de transaction',
          messageTypeIdentifier: 'Type Message',
          functionCode: 'Code métier',
          partialReversalFlag: 'Top. Redressement partiel',
          partialReversalNumber: 'N° Redressement partiel',
          fromAccount: 'Compte ',
          toAccount: '',
          externalOutputStatus: 'Statut sortie',
          externalOutputTimestamp: 'Date sortie',
          unmaskedPan: 'PAN non masqué',
          cardholderAmount: 'Montant Porteur Carte',
          numAut: 'Numéro Autorisation',
          authorizationNotFound: 'Autorisation manquante',
          purchaseNotFound: 'Achat manquant',
          unknownPAN: 'PAN non renseigné',
          duplicateCtrlTop: 'Top. Controle Duplicat',
          latePresentationTop: 'Top. Presentation en retard',
          counterfeitCardTop: 'Top. Contrefaçon',
          offlineFlag: 'Top. hors-ligne',
          offlineAutReversalFlag: 'Top. Annulation hors-ligne',
          offlineAutReversalAmount: 'Montant Annulation hors-ligne',
          voucherImpacts: 'Impacts Voucher',
          donneePrivee: 'Donnée Privée',
          typePaiementOrigine: 'Type Paiement Origine',
          idReseau: 'ID Réseau',
          authorizationReference: 'Ref Autorisation',
          clearingReason: 'Motif du statut métier',
          backofficeStatus: 'Statut Litige',
          backofficeFolderId: 'ID Dossier Litige',
          backofficeFolderName: 'Nom Dossier Litige',
          idOperationAlreadyMatched: 'Identifiant opération déjà réconciliée',
          itp: 'ITP',
          nlsa: 'NLSA',
          disputeReason: 'Raison Litige',
          terminalType: 'Type Terminal',
          cardAcceptorCountryCode: 'Code Pays Accepteur',
          authorizationIdMarchand: 'ID Marchand Autorisation',
          authorizationIdAcceptation: 'ID Acceptation Autorisation',
          actionDateAndTime: 'Date et heure Action',
          documentationIndicator: 'Indicateur Doc',
          feeCollectionControlNumber: 'N° Controle Frais',
          retrievalDocumentCode: 'Code Document',
          processingCode: 'Code Traitement',
          reversalIndicator: 'Indicateur Annulation',
          incomingFileReference: 'Référence Emetteur (CB2C)',
          settlementFileIdentifier: 'Identifiant remise'
        },
        funder: {
          label: 'Libellé Financeur',
          funderContractRef: 'Ref Contrat Financeur',
          funderName: 'Nom du financeur',
          libContratFinanceur: 'Lib contrat financeur',
          statutContratFinanceur: 'Statut contrat financeur',
          funderProfilRef: 'Référence profil financeur'
        },
      }
    },
    distributor: {
      reference: 'Référence',
      name: 'Nom',
      issuerId: 'ID Issuer',
      creationDate: 'Date de création',
      closingDate: 'Date de fermeture',
      country: 'Pays',
      distributorUpdatedSuccess: 'Distributeur {0} mis à jour avec succès',
    },
    param: {
      productViolationslist: 'Erreurs sur le dossier de paramétrage',
      productDifferenceslist: 'Differences entre le paramétrage du système et le dossier de paramétrage',
      paramFile: 'Dossier de paramétrage à contrôler',
      violations: "Violation(s)"
    },
    product: {
      reference: 'Référence du produit',
      name: 'Intitulé',
      distributorRef: 'Référence du distributeur',
      activationDate: 'Date d\'activation',
      deactivationDate: 'Date d\'inactivation',
      status: 'Statut',
      expectedFormat: 'Format attendu :',
      outOnly: 'Donnée non modifiable, à but informatif uniquement',
      earliestUpdate: 'Mise à jour au plus tôt',
      updateHours: 'Horaires de mises à jour : \n - 23:00 \n - 08:00',
      updateDate: 'Date de mise à jour :',
      copiedFrom: 'Produit copié sur la base du produit :',
      fromDistributor: ', du distributeur :',
      createdProductsLastMonth: 'Nombre de produit(s) créé(s) le mois dernier :',
      createdProductsThisMonth: 'Nombre de produit(s) créé(s) dans le mois :',
      editedProductsLastMonth: 'Nombre de produit(s) modifié(s) le mois dernier :',
      editedProductsThisMonth: 'Nombre de produit(s) modifié(s) dans le mois :',
      importFolder: 'Importer un dossier de Paramétrage',
      exportFolder: 'Exporter les produits vers un dossier de paramétrage',
      close: 'Fermer',
      creationSuccess: 'Demande de création produit soumise avec succès (Référence produit : {0}), vous allez être redirigé(e) vers la section demande où vous pourrez consulter la demande créée.',
      infoPre28: 'Ce paramètre est nécessaire au bon fonctionnement du produit. Il est pré-rempli lorsque le PRB-7 et le PRB-11 sont renseignés, le `X` doit être remplacé par l\'indice de clé, les points d\'interrogation sont remplacés lors de la sélection du distributeur et enfin il faut choisir le service BNT entre UMU_SECU et UMU_ISECU.',
      infoPrs323334: 'Ce paramètre dépend des paramètres PRS-25 / 26 / 27 / 28 / 31 et est mis à jour automatiquement lorsqu\'ils sont renseignés.',
      productCopied: 'Produit copié avec succès dans le presse-papiers',
      productImported: 'Produit importé avec succès',
      updateSuccess: 'Demande de mise à jour produit soumise avec succès (Référence produit : {0}), vous allez être redirigé(e) vers la section demande où vous pourrez consulter la demande de mise à jour.'
    },
    request: {
      distributorRef: 'Référence du Distributeur',
      productRef: 'Référence du produit',
      requestStatus: 'Statut de la demande',
      requestId: 'Identifiant de la demande',
      requestDate: 'Date de prise en compte',
      requestType: 'Type de demande',
      requestUser: 'Demandeur',
      distributorDefaultAll: 'Tous les distributeurs (par défaut)',
      allStatus: 'Tous les statuts',
      PENDING: 'En attente',
      DONE: 'Terminée',
      IN_PROGRESS: 'En cours',
      FAILED: 'Echouée',
      CANCELLED: 'Annulée',
      requestCancellation: 'Voulez-vous vraiment annuler cette demande ?',
      cancelSuccess: 'La demande a été annulée avec succès',
      infoDetail: 'Détails de la demande {0} ({1}) avec date de prise en compte au : {2}.',
      statusInfo: 'Statut de la demande : {0}',
      modifiedParamsInProgress: 'Liste des paramètres en cours de modification : (surlignés dans les blocs de paramètres ci-dessous)',
      modifiedParamsPending: 'Liste des paramètres en attente de modification : (surlignés dans les blocs de paramètres ci-dessous)',
      modifiedParamsFailed: 'Liste des paramètres en échec de modification, contactez votre administrateur pour plus d\'informations : (surlignés dans les blocs de paramètres ci-dessous)',
      modifiedParamsCancelled: 'Liste des paramètres qui devaient être modifiés, demande annulée : (surlignés dans les blocs de paramètres ci-dessous)',
      noModifiedParamsFound: 'Aucun paramètre modifié trouvé',
      valueBeforeUpdate: 'Valeur avant modification',
      valueAfterUpdate: 'Valeur après modification',
      param: 'Paramètre',
      undefined: 'Non défini',
      productDetail: 'Détails du produit : {0}',
    },
    user: {
      statut: 'Statut',
      token: 'Token',
      actions: 'Actions',
      selectedIdentification: 'Identifiant',
      selectedEmail: 'Email',
      selectedEmailConfirmation: 'Confirmation de l\'email',
      selectedDescription: 'Description',
      selectedRole: 'Rôle',
      selectedLanguage: 'Langage',
      selectedDistributor: 'Distributeur',
      selectedInternal: 'Interne',
      identificationFormat: 'Champ obligatoire. Champ alphanumérique. 4 caractères minimum. 20 caractères maximum.',
      descriptionFormat: 'Champ alphanumérique. 255 caractères maximum.',
      distributorFormat: 'Le distributeur doit étre connu de la plateforme.',
      deleteUserMsg: 'L\'utilisateur {0} a été supprimé avec succès.',
      reinitPwdMsg: 'Le mot de passe de l\'utilisateur {0} a été réinitialisé avec succès. Un mail vient de lui être envoyé.',
      lockUserMsg: 'L\'utilisateur {0} a été verrouillé avec succès.',
      unlockUserMsg: 'L\'utilisateur {0} a été déverrouillé avec succès.',
      unlockUserResetPwdMsg: 'L\'utilisateur {0} a été déverrouillé avec succès. Son mot de passe était bloqué, il a été réinitialisé et un mail a été envoyé.',
      resetOtpMsg: 'L\'OTP de l\'utilisateur {0} a été réinitialisé avec succès.',
      updateSuccess: 'L\'utilisateur {0} a été mis à jour avec succès.',
      updateSuccessSelfRole: 'L\'utilisateur {0} a été mis à jour avec succès. Le rôle de l\'utilisateur connecté a été changé, vous allez être déconnecté(e) pour appliquer les changements.',
      userCreatedSuccess: 'L\'utilisateur {0} a été créé avec succès.',
    },
    password: {
      login: 'Identifiant ',
      oldPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      newPasswordRepeat: 'Nouveau mot de passe (vérification)',
      passwordFormat: 'Champ obligatoire. 12 caractères minimum. 60 caractères maximum.',
      information: 'Information',
      inputPasswordRules1: 'Le mot de passe doit être compris entre 12 et 60 caractères, dont au moins un caractère alphabétique, un caractère numérique, un caractère spécial, une minuscule et une majuscule.',
      inputPasswordRules2: 'Les caractères blancs et espaces vides ne sont pas autorisés.',
      inputPasswordRules3: 'Il est interdit de réutiliser l\'un des 5 derniers mots de passe.',
      inputPasswordRules4: 'La durée de validité d\'un mot de passe est de 90 jours.',
      inputPasswordRules5: 'Lors de la première connexion d\'un utilisateur avec le mot de passe fourni par le système, le changement de mot de passe est obligatoire.',
      inputPasswordRules6: 'Le renouvellement du mot de passe est obligatoire et a lieu lors de la connexion après saisie de l\'ancien mot de passe.',
      infoChangePassword: 'Le changement de mot de passe se fait via le système Keycloak. En cliquant sur le bouton ci-dessous, vous recevrez un mail de réinitialisation de mot de passe avec les démarches à suivre.',
      emailSentUpdatePwd: 'Un mail de réinitialisation de mot de passe a été envoyé à l\'adresse {0}.',
    },
    profile: {
      id: 'ID',
      description: 'Description',
      internal: 'Internal',
      lot: 'Lot',
      warning: 'Attention !',
      information: 'Cette page est critique pour le fonctionnement de l\'application, ne pas créer/modifier ou supprimer des rôles sans permission d\'un administrateur !',
      permissionsNb: 'Nb Permissions',
      actions: 'Actions',
      close: 'Fermer',
      permissions: 'Permissions',
      rolePermissions: 'LES PERMISSIONS DU RÔLE',
      permissionName: 'Nom',
      permissionDescription: 'Description',
      selectedRoleInternal: 'Rôle interne',
      selectedRolePermissions: 'Permissions',
      selectedRoleLot: 'Lot associé au rôle',
      selectedRoleDescription: 'Description',
      selectedRoleName: 'Nom',
      profileCreatedSuccess: 'Le role {0} a été crée avec succès.',
      profileUpdatedSuccess: 'Le role {0} a été mis à jour avec succès.',
      profileDeletedSuccess: 'Le role {0} a été supprimé avec succès.',
      permission: {
        distributors_all: 'Right to see data from all distributor',
        customerCare_view: 'Right to see customer care',
        distributors_read: 'Right to see distributors',
        distributors_write: 'Right to manage distributors',
        cards_read: 'Permet de récupérer la liste des cartes',
        accounts_read: 'Permet de récupérer la liste des comptes',
        authorizations_read: 'Permet d\'accéder aux détails d\'une autorisation',
        cards_write: 'Permet de mettre à jour la liste des cartes',
        fullPan_view: '[TTNR] to view the full PAN',
        transaction_match: 'Right to match transactions manually',
        ttnr_access: 'Right to access to unmatched transactions manual processing extranet',
        param_control: 'Right to control parametrization file',
        param_difference: 'Right to see difference between parametrization file and system configuration',
        role: 'Right to manage roles',
        customerCare: 'Right to manage customer care',
        beneficiaries_read: 'Permet de récupérer la liste des bénéficiaires',
        commercialProduct_update: 'Right to modify any commercial product',
        parkAdmin_read: 'Right to see affiliates details',
        distributor_read: 'Right to see distributors',
        outstanding_emit: '[TTNR] Right to emit an outstanding',
        user: 'Right to manage users',
        users_read: 'Right to see users',
        users_write: 'Right to modify users',
        users_role: 'Right to manage roles',
        folder_close: '[TTNR] Right to close folder',
        commercialProduct_read: 'Right to see any commercial product',
        authorizations_detail: 'Permet d\'accéder aux détails d\'une autorisation',
        internal: 'Right to see Internal data',
        authorizations_list: 'Right to list authorizations',
        distributor: 'Right to manage distributors',
        cards_unmaskPan: 'Permet d\'avoir l\'option pour afficher les PAN',
        affiliates_read: 'Right to see affiliates',
        affiliates_write: 'Right to manage affiliates',
        technicalProduct: 'Right to manage technical products',
        parkAdmin: 'Right to manage affiliates',
        commercialProduct: 'Right to manage commercial products',
        clearings_read: 'Permet de récupérer la liste des compensations',
        orders_read: 'Permet de récupérer la liste des commandes',
        product: 'Permet de gérer les produits',
        product_read: 'Permet de voir les produits',
        product_write: 'Permet de céer / modifier les produits',
      }
    },
    modal: {
      ERROR_MODAL_LABEL: 'Erreur',
      SUCCESS_MODAL_LABEL: 'Succès',
      CONFIRMATION_MODAL_LABEL: 'Confirmation',
      CONFIRMATION_MODAL_MSG: 'Etes-vous sûr(e) de vouloir continuer ?',
      CONFIRMATION_MODAL_YES_BUTTON: 'Oui',
      CONFIRMATION_MODAL_NO_BUTTON: 'NON',
      ERROR_PRODUCT_CREATION: 'Erreur(s) création produit',
      ERROR_PRODUCT_UPDATE: 'Erreur(s) mise à jour produit',
      COPY_MODAL_LABEL: 'Copie du produit',
      COPY_MODAL_MSG: 'Votre navigateur ne permet pas la copie automatique, veuillez copier manuellement le produit (Clic sur la zone de texte, CTRL + A puis CTRL + C) :',
      PASTE_MODAL_LABEL: 'Import du produit',
      PASTE_MODAL_MSG: 'Votre navigateur ne permet pas le collage automatique, veuillez coller manuellement le produit dans la zone ci-dessous (Copié précédemment sur une page produit avec le bouton Export) :',
    }
  },

  title: {
    login: {
      welcome: 'Bienvenue sur votre espace',
      main: 'IHM Producteur'
    },
    home: {
      welcome: 'Bienvenue'
    },
    breadCrumb: {
      passwordchange: 'Modifier le mot de passe',
      distributorlist: 'Liste des distributeurs',
      distributoredit: 'Modifier le distributeur',
      affiliatelist: 'Affiliés',
      affiliatedetail: 'Détails du contrat affilié',
      affiliateedit: 'Modifier le contrat affilié',
      authorizationlist: 'Autorisations',
      authorizationdetail: 'Détails de l\'autorisation',
      cardlist: 'Cartes',
      carddetail: 'Détails de la carte',
      accountlist: 'Comptes',
      accountdetail: 'Détails du compte',
      beneficiaryservicelist: 'Services bénéficiaires',
      beneficiaryservicedetail: 'Détails service bénéficiaire',
      orderlist: 'Commandes',
      orderdetail: 'Détails commande',
      clearinglist: 'Compensations',
      clearingdetail: 'Détails de la compensation',
      productimport: 'Importer des produits',
      productexport: 'Exporter des produits',
      productlist: 'Produits',
      productdetail: 'Détails du produit',
      productedit: 'Modification du produit',
      productcopy: 'Copie et Création du produit',
      productcreate: 'Créer un produit',
      requestlist: 'Liste des demandes',
      requestdetails: 'Détails de la demande',
      requestedit: 'Modification la demande',
      paramcontrol: 'Contrôle dossier de paramétrage',
      profilecreate: 'Créer un rôle',
      profilelist: 'Liste des rôles',
      profileedit: 'Modifier un rôle',
      usercreate: 'Créer un utilisateur',
      userlist: 'Liste des utilisateurs'
    },
    distributors: 'Distributeurs ',
    distributorsList: 'Liste des distributeurs',
    distributorsCreate: 'Créer un distributeur',
    distributorsEdit: 'Modifier le distributeur',
    products: 'Produits ',
    product: {
      list: 'Liste des produits',
      detail: 'Détails du produit',
      edit: 'Modification du produit',
      import: 'Importer des produits',
      export: 'Exporter les produits',
      create: 'Créer un produit'
    },
    commercialProductsList: 'Liste des produits commerciaux',
    commercialProductsCreate: 'Créer un produit commercial',
    technicalProductsList: 'Liste des produits techniques',
    technicalProductsCreate: 'Créer un produit technique',
    affiliates: 'Contrats affiliés',
    affiliate: {
      list: 'Contrats affiliés',
      details: 'Détails du Contrat affilié',
      edit: 'Modifier le Contrat affilié'
    },
    transactions: 'Transactions non rapprochées',
    beneficiaries: 'Services bénéficiaires',
    beneficiaryservice: {
      list: 'SERVICES BÉNÉFICIAIRES',
      details: 'DÉTAILS SERVICE BÉNÉFICIAIRE'
    },
    card: {
      list: 'Cartes',
      details: 'Détails de la carte'
    },
    account: {
      list: 'Comptes',
      details: 'Détails du compte'
    },
    authorization: {
      list: 'Autorisations',
      details: 'Détails de l\'autorisation'
    },
    param: {
      control: 'Contrôle dossier de paramétrage'
    },
    clearing: {
      list: 'Compensations',
      details: 'Détails de la compensation'
    },
    user: {
      list: 'Liste des utilisateurs',
      creation: 'Créer un utilisateur',
      edition: 'Modifier l\'utilisateur',
      info: {
        unlockUser: 'Déverrouiller l\'utilisateur',
        deleteUser: 'Supprimer l\'utilisateur',
        lockUser: 'Verrouiller l\'utilisateur',
        reinitUserPwd: 'Réinitialiser le mot de passe de l\'utilisateur',
        editUser: 'Modifier les informations de l\'utilisateur',
        resetOtp: 'Réinitialiser l\'OTP'
      }
    },
    profile: {
      list: 'Liste des rôles',
      creation: 'Créer un rôle',
      edition: 'Modifier le rôle'
    },
    request: {
      list: 'Liste des demandes',
      details: 'Détails de la demande'
    },
    accounts: 'Comptes',
    orders: 'Commandes',
    admin: 'Administration',
    usersList: 'Liste des utilisateurs',
    usersCreate: 'Créer un utilisateur',
    passwordchange: 'Modifier le mot de passe',
    profilesPage: 'Gérer les rôles',
    batchPage: 'Planification des batchs'
  },

  error: {
    TECHNICAL_ERROR: 'Erreur technique',
    MANDATORY_CRITERIA: 'Critère obligatoire.',
    UNAUTHORIZED_NB_RESULT: 'Nombre de résultats trop elevé. Veuillez affiner votre recherche.',
    EXCEEDED_DISPLAY_LIMIT: 'Nombre de résultats trop élevé. Tous les résultats n\'ont pas été affichés',

    USER_ACCOUNT_EXPIRED: 'Accès expiré',
    USER_ACCOUNT_LOCKED_BY_TOO_MANY_WRONG_AUTHENTICATIONS: 'Accès bloqué. Trop de tentatives de connexions erronées.',
    USER_ACCOUNT_LOCKED_BY_ADMINISTRATOR: 'Accès bloqué par un administrateur',
    USER_AUTHENTICATION_KO: 'Login et/ou mot de passe incorrect',
    USER_UNKNOW_ERROR: 'Erreur inconnue. Veuillez réessayer dans quelques instants.\nSi le problème persiste, contactez un admninistrateur.',
    USER_AUTHENTICATION_MISSING: 'Veuillez renseigner votre login et mot de passe',
    IHM_DISTRIB_INCOMPLETE_DATA: 'Erreur de récupération des données distributeur et/ou produit',
    USER_DOESNT_EXISTS: 'L\'utiliseur n\'existe pas',
    USER_ALREADY_EXISTS: 'L\'utiliseur existe déjà',
    USER_INCONSISTANT_DATABASE: '',
    USER_ROLE_DOESNT_EXISTS: 'Le rôle n\'existe pas',
    USER_ROLE_ALREADY_EXISTS: 'Le rôle existe déjà',
    USER_ACCOUNT_CANT_BE_LOCKED: 'Le compte utilisateur ne peut pas être bloqué',
    USER_ACCOUNT_CANT_BE_UNLOCKED: 'Le compte utilisateur ne peut pas être débloqué',
    USER_PASSWORD_CHANGING_FAILED: 'Le changement de mot de passe a échoué',
    USER_PASSWORD_CHANGING_FAILED_DUE_TO_HISTORY: 'Veuillez respecter les conditions, il est interdit de réutiliser l\'un des 5 derniers mots de passe',
    USER_PASSWORD_CHANGING_FAILED_DUE_TO_POLICY: 'Veuillez respecter la politique de mot de passe',
    USER_PASSWORD_CHANGING_FAILED_DUE_TO_PASSWORD_LENGTH: 'La longueur du mot de passe ne respecte pas les conditions',
    USER_PASSWORD_RESET_FAILED: 'La réinitialisation du mot de passe a échouée',
    USER_INVALID_OPERATION: '',

    // AUTHORIZATION_MISSING_MANDATORY_CRITERIA: 'Un des 3 critères (Référence Distributeur / N° Porteur / Identifiant Carte) est obligatoire.',
    AUTHORIZATION_MISSING_MANDATORY_CRITERIA: 'Un des 2 critères (Référence Distributeur / Identifiant Carte) est obligatoire.',
    AUTHORIZATION_MANDATORY_CRITERIA: 'Critère obligatoire.',
    AUTHORIZATION_CARD_NUMBER_FORMAT: 'Nombre de 16 à 19 chiffres.',
    AUTHORIZATION_CARD_ID_FORMAT: 'Nombre à 20 chiffres maximum.',
    AUTHORIZATION_AUTHORIZATION_NUMBER_FORMAT: 'Nombre à 6 chiffres maximum.',
    AUTHORIZATION_MERCHANT_ID_FORMAT: '7 caractères maximum.',
    AUTHORIZATION_AMOUNT_FORMAT: 'Nombre à 10 chiffres maximum.',
    AUTHORIZATION_MAX_DATE_RANGE: 'La différence entre la date de début et la date de fin ne doit pas excéder {range} jour(s)',

    VALIDATION_MANDATORY_CRITERIA: 'Critère obligatoire.',
    VALIDATION_FORMAT: 'Veuillez respecter le format requis.',
    VALIDATION_EMAIL_CONFIRMATION: 'Les champs email et confirmation de l\'email ne sont pas égaux !',

    CARDS_CARD_ID_MIN_LENGTH: 'Vous devez donner 5 caractères au minimum pour Identifiant carte.',
    CARDS_CARD_ID_MAX_LENGTH: 'Vous ne pouvez donner que 25 caractères maximum pour Identifiant carte.',
    CARDS_PAN_MIN_LENGTH: 'Vous devez donner 11 caractères au minimum pour Numéro de carte.',
    CARDS_PAN_MAX_LENGTH: 'Vous ne pouvez donner que 19 caractères maximum pour Numéro de carte.',

    COMPENSATION_DATE_MANDATORY_CRITERIA: 'La date de transaction ou la date de traitement est obligatoire.',
    COMPENSATION_MISSING_MANDATORY_CRITERIA: 'Un des 4 critères (Référence Distributeur / N° Porteur / Identifiant Carte / Identifiant transaction) est obligatoire.',
    COMPENSATION_DATE_TRANSACTION_RANGE: 'Le délai entre la date de début et la date de fin ne doit pas excéder 3 mois',
    COMPENSATION_DATE_TRAITEMENT_RANGE: 'Le délai entre la date de début et la date de fin ne doit pas excéder 3 mois',

    BAD_REQUEST: 'Aucune opération trouvée pour ces critères. Contactez un admnistrateur si le problème persiste.',
    NOT_FOUND: 'Aucun résultat trouvé pour ces critères.',
    NO_OPERATION_FOUND: 'Aucun résultat trouvé pour ces critères.',
    SERVICE_EXCEPTION: 'Erreur interne serveur',
    UNAUTHORIZED: 'Action non autorisée. Contactez votre administrateur pour plus de détails.',
    BAD_DATA_FORMAT: 'Mauvais format de données',

    // ##
    // # WebService
    // # Ces valeurs viennent de l'enumeration CdjResponseCode de la couche WebService (net.atos.wlp.cdj.opc.contract)
    // # Elles sont préfixées par WEBS_ pour bien les distinguer et empecher les doublons.
    // # Basé sur la version du 14/02/13   ( <3 !)
    // ##
    WEBS_SUCCESS: 'Succès !',
    WEBS_UNKNOWN_DISTRIBUTOR: 'Distributeur inconnu !',
    WEBS_MANDATORY_DATA_MISSING: 'Donnée obligatoire manquante !',
    WEBS_UNKNOWN_ERROR: 'Erreur inconnue !',
    WEBS_UNKNOWN_PRODUCT: 'Produit inconnu !',
    WEBS_UNKNOWN_PROFILE: 'Profil inconnu !',
    WEBS_UNKNOWN_FUNDER_CONTRACT: 'Contrat financeur inconnu !',
    WEBS_VIOLATED_CONSTRAINT: 'Violation de contrainte !',
    WEBS_UNCONSISTENT_LIMIT: 'Limite incohérente !',
    WEBS_UNCONSISTENT_PERIOD: 'Période incohérente !',
    WEBS_INACTIVE_PRODUCT: 'Produit inactif !',
    WEBS_FUNDER_CONTRACT_CLOSED: 'Contrat financeur fermé !',
    WEBS_FUNDER_CONTRACT_ALREADY_EXISTS: 'Contrat financeur déjà exisant !',
    WEBS_BENEFICIARY_SERVICE_ALREADY_EXISTS: 'Service bénéficiaire déjà existant !',
    WEBS_BENEFICIARY_SERVICE_CLOSED: 'Service bénéficiaire clôturé !',
    WEBS_UNCONSISTENT_FUNDER_CONTRACT: 'Contrat financeur incohérent !',
    WEBS_FIRST_CARD_ALREADY_ISSUED: 'Premiere carte déjà délivrée !',
    WEBS_UNKNOWN_CARD: 'Carte inconnue !',
    WEBS_CARD_NOT_LINKED_TO_DISTRIBUTOR: 'Carte non reliée à un distributeur !',
    WEBS_ACTIVATION_NOT_ALLOWED: 'Activation non autorisée !',
    WEBS_ACTIVATION_LIMIT_DATE_EXCEEDED: 'Date d\'activation dépassée !',
    WEBS_LOAD_OPERATION_NOT_AUTHORIZED: 'Opération de chargement non autorisée !',
    WEBS_UNKNOWN_ORDER_GROUP: 'Unknow order group !',
    WEBS_UNCONSISTENT_BENEFICIARY_SERVICE: 'Service bénéficiaire incohérent !',
    WEBS_INVALID_CARD_ORDER_STATUS: 'Le statut de la commande de la carte est invalide !',
    WEBS_PAN_DECRYPTION_FAILED: 'Le déchiffrage du pan a échoué !',
    WEBS_ACTIVATION_LIMIT_: 'Limite d\'activation !',
    WEBS_CARD_NOT_CREATED: 'Carte non créée !',
    WEBS_EXPIRY_DATE_MANDATORY: 'Date d\'expiration obligatoire !',
    WEBS_CARD_STATUS_NOT_VALID_FOR_DEACTIVATION: 'Le statut de la carte ne permet pas une désactivation !',
    WEBS_INVALID_BLOCKING_REASON: 'Raison de blocage invalide !',
    WEBS_CARD_LOSS_DATE_OUT_OF_BOUNDS: 'Date perte de carte innaccessible !',
    WEBS_UNCONSISTENT_VOUCHER_VALIDITY: 'Période invalide !',
    WEBS_REFUSED_ACCOUNT_NOT_FOUND: 'Compte introuvable !',
    WEBS_REFUSED_ACCOUNT_CLOSED: 'Compte clôturé !',
    WEBS_REFUSED: 'Refus !',
    WEBS_PROFILE_ALREADY_EXISTS: 'Profil déjà existant !',
    WEBS_UNKNOWN_BENEFICIARY_SERVICE: 'Service bénéficiaire inconnu !',
    WEBS_UNKNOWN_FUNDER_CONTRACT_PROFILE: 'Unknow funder contract profile !',
    WEBS_UNKNOWN_BENEFICIARY_PROFILE: 'Profile bénéficiaire inconnu !',
    WEBS_RESUSED_AMOUNT_MISMATCHED: 'Montant de la demande incohérent !',
    WEBS_REFUSED_AMOUNT_MISMATCH_PERIOD: 'Montant refusé non conforme à la période !',
    WEBS_REFUSED_CONTRACT_VIOLATION: 'Violation de contrat refusée !',
    WEBS_REFUSED_VELOCITY_LIMIT_SLIDING_PERIOD: 'Restriction sur période glissante non respectée !',
    WEBS_REFUSED_MIN_AMOUNT_CHECKER: 'Vérificateur de montant min refusé !',
    WEBS_REFUSED_MAX_AMOUNT_CHECKER: 'Vérificateur de montant max refusé ',
    WEBS_REFUSED_BALANCE_LIMIT: 'Solde limite refusé !',
    WEBS_UNCONSISTENT_VOUCHER_VALIDITY_PERIOD: 'Période invalide !',
    WEBS_REFUSED_AMOUNT_MISMATCHED: 'Montant de la demande incohérent !',
    WEBS_UNKNOWN_ISSUER: 'Emetteur inconnu !',
    WEBS_NOT_DISTRIB_ISSUER: 'Émetteur non distributeur ',
    WEBS_BAD_ORDER_INTERNAL_STATUS: 'Statut de la commande incorrect !',
    WEBS_MAX_INPUT_LIST_EXCEEDED: 'Limite maximale de liste d\'entrée dépassée !',
    WEBS_CURRENCY_CONTRACT_VIOLATION: 'Violation de contrat de change !',
    WEBS_CARD_ALREADY_ORDERABLE: 'Carte déjà distribuée !',
    WEBS_ISSUER_ALREADY_EXISTS: 'Le distributeur existe déjà !',
    WEBS_CARD_STATUS_INVALID: 'Statut de la carte invalide !',
    WEBS_ORDER_NOT_UNIQUE: 'Commande déjà existante !',

    PARAM_CONTROL_NO_RESULT: 'Aucune erreur sur le dossier de paramétrage :',
    PARAM_CONTROL_NO_DIFFERENCE: 'Aucune difference entre le paramétrage du système et le dossier de paramétrage :',
    PARAM_CONTROL_ERROR: 'Erreur lors du contrôle du dossier de paramétrage :',
    PARAM_CONTROL_NO_FILE_SELECTED: 'Aucun fichier sélectionné',
    PRODUCT_MISSING_MANDATORY_CRITERIA: 'La Référence Distributeur est obligatoire.',

    ITP_ERROR: 'Erreur survenue en contactant le service ITP',
    OPC_ERROR: 'Erreur survenue en contactant le service OPC',
    INVALID_TRANSACTION_STATUS: 'Statut de transaction incorrect',
    INVALID_OPERATION_ID: 'ID operation incorrect',
    INVALID_MAX_RESULTS: 'Nombre de résultats maximum incorrect',
    TRANSACTION_NOT_FOUND: 'Aucune opération trouvée pour ces critères.',
    TOO_MANY_RESULTS: 'Nombre de résultats trop elevé. Veuillez affiner votre recherche.',

    AT_LEAST_ONE_ELEMENT_MUST_EXISTS: 'Donnée ne pouvant pas être supprimée parce qu\'il doit exister au moins une occurrence dans le référentiel.',

    'Could not receive Message.': 'La requête n\'a pas aboutie. Merci de réessayer plus tard',
    INVALID_FORM_PRODUCT: 'Formulaire produit invalide, veuillez corriger les erreurs pour valider votre saisie',
    NO_REQUESTS_FOUND: 'Aucune demande trouvée pour ces critères.',
    CONVERSION_ERROR: 'Erreur lors de la création produit, les contraintes ci-dessous ne sont pas respectées :',
    COM_001: 'Distributeur non trouvé',
    COM_002: 'Erreur lors de la création produit, les contraintes ci-dessous ne sont pas respectées :',
    COM_002_UPDATE: 'Erreur lors de la mise à jour produit, les contraintes ci-dessous ne sont pas respectées :',
    COM_003: 'Erreur technique',
    COM_004: 'Produit non trouvé',
    COM_005: 'Erreur lors de la comparaison produits',
    COM_006: 'Produit technique invalide ou non trouvé',
    COM_007: 'Produit non modifié',
    COM_008: 'Paramètres non autorisés à la modification',
    COM_009: 'Produit invalide',
    COM_203: 'Demande de changement de paramètre produit non trouvée (COM_203), contactez un administrateur',
    INVALID_DATE_PRODUCT: 'La date doit être au minimum supérieure de 2 jours par rapport à la date du jour',
    PRODUCT_EMPTY: 'Erreur lors du chargement du produit, redirection vers la liste des produits',
    AUTHORIZATION_EMPTY: 'Erreur lors du chargement de l\'autorisation, redirection vers la liste des autorisations',
    CLEARING_EMPTY: 'Erreur lors du chargement de la compensation, redirection vers la liste des compensations',
    AFFILIATE_CONTRACT_EMPTY: 'Erreur lors du chargement du contrat affilié, redirection vers la liste des contrats affiliés',
    BENEFICIARY_SERVICE_EMPTY: 'Erreur lors du chargement du service bénéficiaire, redirection vers la liste des services bénéficiaires',
    CARD_EMPTY: 'Erreur lors du chargement de la carte, redirection vers la liste des cartes',
    ACCOUNT_EMPTY: 'Erreur lors du chargement du compte, redirection vers la liste des comptes',
    ORDER_EMPTY: 'Erreur lors du chargement de la commande, redirection vers la liste des commandes',
    INVALID_SCHEME: 'Réseau carte invalide ou non supporté (Vérifiez champs PRB-11 / PRB-15 / PRE-17 / PRE-28 / PRO-2)',
    INVALID_JSON_PRODUCT: 'Erreur lors de l\'import du produit, le produit collé en JSON est invalide',
    NO_UPDATED_PARAMS: 'Aucun paramètre n\'a été trouvé pour la mise à jour',
    REQUEST_EMPTY: 'Erreur lors du chargement de la demande, redirection vers la liste des demandes',
    IHM_SSO_SEND_MAIL_ERROR: 'Erreur lors de l\'envoi du mail pour effectuer les actions nécessaires',
    IHM_SSO_NO_CREDENTIALS: 'Erreur lors de la réinitialisation de l\'OTP, l\'utilisateur n\'a pas d\'identifiants',
    IHM_SSO_NO_CONF_OTP: 'Erreur lors de la réinitialisation de l\'OTP, l\'utilisateur n\'a pas configuré son OTP',
  }
}
